export default class MediaWidthObserver {
  constructor(setObserver = false) {
    this.parentNames = ['.cblock-video-embed', '.cblock-image', '.wp-block-video'];
    this.childNames = ['iframe', 'img', 'video'];
    this.init(setObserver);
  }

  setMediasWidthVar() {
    this.parentNames.forEach(parentSelector => {
      const parents = document.querySelectorAll(parentSelector);
      parents.forEach(parent => {
        this.childNames.forEach(childSelector => {
          const child = Array.from(parent.querySelectorAll(childSelector)).filter( el => el.getBoundingClientRect().width > 0 );
					child.length && parent.style.setProperty('--media-width', `${child[0].getBoundingClientRect().width}px`);
        });
      });
    });
  }

  init(setObserver) {
    this.setMediasWidthVar();
    if (setObserver) {
      const resizeObserver = new ResizeObserver(() => {
        this.setMediasWidthVar();
      });
      resizeObserver.observe(document.body);
    }
  }
}
